import request from './service/index'

export function entryClassificationSearch_Api(){//查询词条
    return request({
        url:'CMS/entry/entry_classification',
        method:'get',
    });
}

export function createEntryClassification_Api(data){//创建词条
    return request({
        url:'CMS/entry/entry_classification',
        method:'post',
        data:data
    });
}

export function updateEntryClassification_Api(data){//更新词条
    return request({
        url:'CMS/entry/entry_classification',
        method:'put',
        data:data
    });
}

export function deleteEntryClassification_Api(data){//删除词条
    return request({
        url:'CMS/entry/entry_classification',
        method:'delete',
        data:data
    });
}

export function entryList_Api(data){
    return request({
        url:'CMS/entry/entry_list',
        method:'post',
        data:data
    });
}

export function deleteEntryList_Api(data){
    return request({
        url:'CMS/entry/entry_list',
        method:'delete',
        data:data
    });
}

export function entryCount_Api(){
    return request({
        url:'CMS/entry/entry_count',
        method:'get',
    });
}

export function outputEntry_Api(data){
    return request({
        url:'CMS/entry/output',
        method:'post',
        data:data
    });
}

export function entryDetail_Api(id){
    return request({
        url:`CMS/entry/entry_detail?entry_id=${id} `,
        method:'get',
    });
}

export function createEntryDetail_Api(data){
    return request({
        url:'CMS/entry/entry_detail',
        method:'post',
        data:data
    });
}

export function updateEntryDetail_Api(data){
    return request({
        url:'CMS/entry/entry_detail',
        method:'put',
        data:data
    });
}

export function deleteEntryDetail_Api(data){
    return request({
        url:'CMS/entry/entry_detail',
        method:'delete',
        data:data
    });
}


// WEBPACK FOOTER //
// ./src/apis/entry.api.js